import React from 'react';
import PropTypes from 'prop-types';
import './ThermostatDisplayBox.css';
import { StatusIndicator } from '../../../../../StatusIndicator';
import { SettingIndicator } from '../../../../../SettingIndicator';
import { DemandIndicator } from '../../../../../DemandIndicator';

export const ThermostatDisplayBox = (props) => {
  const {
    ambientTemperature,
    connectionState,
    displayName,
    fanMode,
    isFanRunning,
    isOccupied,
    mode,
    state,
    targetTemperature,
  } = props;
  const isDisabled = connectionState !== 'online';
  const thermostatDisplayBoxClasses = `thermostat-display-box${isDisabled ? ' thermostat-display-box--reset' : ''}`;

  return (
    <div className={thermostatDisplayBoxClasses}>
      <div className="thermostat-header">
        <StatusIndicator state={connectionState} />
        <span className="thermostat-header__zone">{displayName}</span>
      </div>
      <div className="thermostat-body">
        <div className="thermostat-settings">
          <span className="thermostat-settings__item">
            <SettingIndicator reset={isDisabled} setting={mode} />
          </span>
          <span className="thermostat-settings__item thermostat-settings__item--actual-temp">{ambientTemperature}</span>
          <span className="thermostat-settings__item">{targetTemperature}</span>
        </div>
        <div className="thermostat-settings">
          <span className="thermostat-settings__item">
            <DemandIndicator demand="state" active={state !== 'off'} disabled={isDisabled} setting={state} />
          </span>
          <span className="thermostat-settings__item">
            <DemandIndicator demand="isFanRunning" active={isFanRunning} disabled={isDisabled} />
          </span>
          <span className="thermostat-settings__item">
            <DemandIndicator demand="isOccupied" active={isOccupied} disabled={isDisabled} />
          </span>
        </div>
        <div className="thermostat-settings thermostat-settings--fan">{fanMode}</div>
      </div>
    </div>
  );
};

ThermostatDisplayBox.propTypes = {
  ambientTemperature: PropTypes.string.isRequired,
  connectionState: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  fanMode: PropTypes.string.isRequired,
  isFanRunning: PropTypes.bool.isRequired,
  isOccupied: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  targetTemperature: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};
